import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "card"]
  static values = { enabled: { type: Boolean, default: true } }

  connect() {
    if (this.enabledValue) {
      this.boundHandleScroll = this.handleScroll.bind(this)
      this.containerTarget.addEventListener('scroll', this.boundHandleScroll)
      
      // Check initial scroll state
      this.handleScroll()
      
      // Also check on window resize in case content changes
      this.boundHandleResize = this.handleScroll.bind(this)
      window.addEventListener('resize', this.boundHandleResize)
    }
  }

  disconnect() {
    if (this.boundHandleScroll) {
      this.containerTarget.removeEventListener('scroll', this.boundHandleScroll)
    }
    if (this.boundHandleResize) {
      window.removeEventListener('resize', this.boundHandleResize)
    }
  }

  handleScroll() {
    const container = this.containerTarget
    const { scrollLeft, scrollWidth, clientWidth } = container
    
    // Check if content is actually scrollable
    const isScrollable = scrollWidth > clientWidth
    
    if (!isScrollable) {
      // Remove peek shadows if content doesn't overflow
      this.cardTargets.forEach(card => {
        card.classList.remove('peek-shadow-left', 'peek-shadow-right')
      })
      return
    }
    
    // Calculate which cards should have peek shadows
    this.cardTargets.forEach((card, index) => {
      const cardRect = card.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()
      
      // Check if card is partially visible on the right edge
      const isPartiallyVisibleRight = cardRect.left < containerRect.right && 
                                     cardRect.right > containerRect.right
      
      // Check if card is partially visible on the left edge  
      const isPartiallyVisibleLeft = cardRect.right > containerRect.left && 
                                    cardRect.left < containerRect.left
      
      // Add/remove shadow classes based on visibility
      if (isPartiallyVisibleRight) {
        card.classList.add('peek-shadow-right')
        card.classList.remove('peek-shadow-left')
      } else if (isPartiallyVisibleLeft) {
        card.classList.add('peek-shadow-left')
        card.classList.remove('peek-shadow-right')
      } else {
        card.classList.remove('peek-shadow-left', 'peek-shadow-right')
      }
    })
  }

  enabledValueChanged() {
    if (this.enabledValue) {
      this.connect()
    } else {
      this.disconnect()
      // Remove all peek shadows when disabled
      this.cardTargets.forEach(card => {
        card.classList.remove('peek-shadow-left', 'peek-shadow-right')
      })
    }
  }
}